import React, {Component} from 'react';
import appleBadge from './applebadge.png'
import androidbadge from './androidbadge.png'
import youtubeIcon from './YouTube.png'
import './Project.css';
class Project extends Component {

    render() {

        var name = this.props.data['name'];
        var description = this.props.data['description'];
        var icon = this.props.data['icon'];
        var ioslink = this.props.data['link-ios'];
        var androidlink = this.props.data['link-android'];
        var youtubelink = this.props.data['link-youtube'];
        var roles = this.props.data['roles'];

        if(ioslink !==undefined){

            ioslink  = <a href={ioslink} target="_blank" rel="noopener noreferrer"><img className="AppleStoreBadge" src={appleBadge} alt={name+" is available on the App Store"}/></a>
        }

        if(androidlink !==undefined){

            androidlink  = <a href={androidlink} target="_blank" rel="noopener noreferrer"><img className="AppleStoreBadge" src={androidbadge} alt={name+" is available on the Play store"}/></a>
        }

        if(youtubelink!==undefined){

            youtubelink = <a href={youtubelink} target="_blank" rel="noopener noreferrer"><img className="YoutubeBadge" src={youtubeIcon} alt={"see "+name+" in action on Youtube"}/></a>

        }

        if(roles!==undefined){

            roles = <div>Roles: {roles}</div>

        }

        return <div className="Project">
                <div className="FirstRow">
                    <div className="IconColumn">
                        <img className="AppIcon" alt={name+" icon"}src={icon}/>
                        {ioslink}
                        {androidlink}
                        {youtubelink}
                    </div>
                    <div className="DescriptionColumn">
                        <div className="Description">{description}</div>
                        <div className="Roles">{roles}</div>
                    </div>
                </div>
        </div>;

    }

}

export default Project;


// WEBPACK FOOTER //
// ./src/Project.js